import React from "react";

class Confirm extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			checkin: "Check In"
		};
		this.handleClick = this.handleClick.bind(this);
	}

	handleClick(event) {
		this.setState({checkin: "Checking in..."});
		this.props.handleCheckin();
	}

	render() {
		return (
			<div className="confirmation-screen">
				<div className="confirmation-container">
					<h1>{this.props.details.firstName} {this.props.details.lastName}</h1>
					<img src={ process.env.PUBLIC_URL + '/images/icon-ovals.svg' } alt="FFF" className="icon-ovals" />
					<p>Please confirm your check-in.</p>
					<button onClick={this.props.handleCheckinCancel}>Cancel</button>&nbsp;&nbsp;
					<button onClick={this.handleClick}>{this.state.checkin}</button>
				</div>
			</div>
		);
	}
}

export default Confirm;



// WEBPACK FOOTER //
// ./src/components/Confirm.js